import React, { useState, useRef } from 'react';
import { Row, Col, Select, Pagination } from 'antd';
import PropTypes from 'prop-types';
import PostCard from './PostCard';
import Breadcrubms from './Breadcrumbs';
import Spacer from './Spacer';

const filterContent =
  window.enervent.translations.filterContent || 'Suodata sisältöjä'; // eslint-disable-line no-undef
const filterByTheme =
  window.enervent.translations.filterByTheme || 'Suodata teemoittain'; // eslint-disable-line no-undef
const articlesPageTitle =
  window.enervent.translations.newsAndArticles || 'Uutiset ja artikkelit'; // eslint-disable-line no-undef

const ArticleArchive = ({
  archive_posts: posts,
  category_name: categoryName,
  categories,
}) => {
  const scrollToRef = useRef();
  const pageSize = 9;
  const [currentPage, setCurrentPage] = useState(1);
  const postsToShow = posts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="article-archive" ref={scrollToRef}>
      <Breadcrubms title={articlesPageTitle} />
      <Spacer size="md" />
      <Row className="article-archive__filter">
        <Col
          xs={{
            offset: 0,
            span: 24,
          }}
          md={{ offset: 0, span: 8 }}
          className="article-archive__filter-left"
        >
          <Spacer size="md" />
          <h2 className="article-archive__filter-title">{filterContent}</h2>
          <Spacer size="md" />
        </Col>
        <Col
          xs={{
            offset: 0,
            span: 24,
          }}
          md={{ offset: 0, span: 8 }}
          className="article-archive__filter-center"
        >
          <Spacer size="md" />
          <p className="article-archive__filter-label">{filterByTheme}</p>
          <Spacer size="sm" />
          <Select
            defaultValue={categoryName}
            onChange={(value) => {
              const categoryUrl = categories.find(
                (category) => category.slug === value
              ).url;
              window.location.href = categoryUrl; // eslint-disable-line no-undef
            }}
            options={
              categories &&
              categories.map((category) => ({
                value: category.slug,
                label: category.name,
              }))
            }
          />
          <Spacer size="md" />
        </Col>
        <Col
          xs={{
            offset: 0,
            span: 24,
          }}
          md={{ offset: 0, span: 8 }}
          className="article-archive__filter-right"
        />
      </Row>
      <Spacer size="md" />
      <Row gutter={20}>
        {postsToShow.map((post) => (
          <Col
            xs={{
              offset: 0,
              span: 24,
            }}
            sm={{ offset: 0, span: 12 }}
            md={{ offset: 0, span: 8 }}
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <PostCard post={post} cardstyle="secondary" />
            <Spacer size="md" />
          </Col>
        ))}
      </Row>
      <Spacer size="md" />
      <Pagination
        current={currentPage}
        defaultPageSize={pageSize}
        onChange={(e) => {
          if (scrollToRef && scrollToRef.current) {
            scrollToRef.current.scrollIntoView();
          }
          setCurrentPage(e);
        }}
        total={posts.length}
      />
    </div>
  );
};

ArticleArchive.propTypes = {
  archive_posts: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        srcset: PropTypes.string.isRequired,
        placeholder: PropTypes.string.isRequired,
        placeholderBase64: PropTypes.string.isRequired,
        base64: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        alt: PropTypes.string.isRequired,
      }).isRequired,
      title: PropTypes.string.isRequired,
      excerpt: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  category_name: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ArticleArchive;
